import { Core } from '../core';
import { SunbedModelEntity } from './interfaces';

export const SunbedModelsStore = Core.Stores.create<SunbedModelEntity>('/sunbeds/models');
